import React from "react"
import WorldHeart from "../../../static/icon-world-heart.svg"

const Marquee = ({ slice }) => {
  return (
    <div class="marquee">
      <div class="marquee__inner" aria-hidden="true">
        {slice.items.map(i => (
          <>
            <span><WorldHeart /> {i.text.text}</span>
            <span><WorldHeart /> {i.text.text}</span>
            <span><WorldHeart /> {i.text.text}</span>
            <span><WorldHeart /> {i.text.text}</span>
            </>
          ))}
      </div>
    </div>
  )
}

export default Marquee
